module.exports = __webpack_public_path__ + "img/store_title02.5164b650.png";